'use client';

import React from 'react';
import Link from './Link';
import { FMSItem } from './types';
import Accordion from './Accordion';
import useTranslation from '../../translation/useTranslation';
import Spacer from './Spacer';
import Group from './Group';
import Grid from './Grid';

export function MenuItem(item: FMSItem) {
  const { type } = item;
  const { language } = useTranslation();

  if (type === 'link') {
    const { href, title, track } = item;
    return (
      <Link key={track} data-trackid={track} href={href}>
        {title[language]}
      </Link>
    );
  }

  if (type === 'accordion') {
    const { children, title, track } = item;
    return (
      <Accordion key={track} title={title[language]}>
        {(children || []).map((sub) => (
          <Link key={sub.id} data-trackid={sub.track} href={sub.href}>
            {sub.title[language]}
          </Link>
        ))}
      </Accordion>
    );
  }

  if (type === 'spacer') {
    return <Spacer />;
  }

  if (type === 'list-group') {
    const { children, title } = item;
    return (
      <Group title={title}>
        {(children || []).map((child, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <MenuItem key={`${child.type}-${index}`} {...child} />
        ))}
      </Group>
    );
  }

  if (type === 'grid-group') {
    const { children, title } = item;
    return (
      <Grid title={title}>
        {(children || []).map((child) => (
          <Grid.Item
            key={child.id}
            icon={child.icon}
            href={child.href}
            data-trackid={child.track}
          >
            {child.title[language]}
          </Grid.Item>
        ))}
      </Grid>
    );
  }

  return null;
}

export default MenuItem;
